import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=4d188d01&scoped=true&"
import script from "./draw.vue?vue&type=script&lang=js&"
export * from "./draw.vue?vue&type=script&lang=js&"
import style0 from "./draw.vue?vue&type=style&index=0&id=4d188d01&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d188d01",
  null
  
)

export default component.exports